import { useIntersectionObserver } from "./Utilities/useIntersectionObserver";

import { useRef } from "react"

import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function Header (props){
    const { setFilter } = props
    const searchRef = useRef(null)
    useIntersectionObserver({ 
        ref: searchRef,
        options: { threshold: [0, 1]},
        callback: (entries) => {
            if (entries[0].intersectionRatio < 1){
                searchRef.current.classList.add("shadow")
            }
            // fully intersects 
            else if (entries[0].intersectionRatio === 1){
                searchRef.current.classList.remove("shadow")
            }
        }
    })

    return (
        <>
            <div id="galleryHeader">
                <h1>All Modules</h1>
            </div>
            <div id="searchFilter" ref={searchRef} role="navigation">
                <div className="searchIconGroup">
                    <input aria-label="Search" id="searchBar" role="search" type="text" placeholder="Search for module!" onChange={(e)=>setFilter(e.target.value)}/>
                    <FontAwesomeIcon icon={faSearch} />
                </div>
            </div>
        </>
    )
}

export default Header